module.exports = __webpack_public_path__ + "static/nafidha-df496d4524abf3d019d43c4ae1ac01f2.jpeg";